<opac-table>
  <opac-table-row>
    <!-- libraryName -->
    <opac-table-cell-header *ngIf="showLibraryCell">{{ 'physical.library' | translate }}</opac-table-cell-header>
    <!-- availability -->
    <opac-table-cell-header>{{ 'physical.availability' | translate }}</opac-table-cell-header>
    <!-- each header -->
    <opac-table-cell-header *ngFor="let header of physicalRecordHeaders">{{ header }}</opac-table-cell-header>
    <!-- button cell -->
    <opac-table-cell-header></opac-table-cell-header>
  </opac-table-row>

  <opac-table-row *ngFor="let item of physicalRecordsDisplayList">
    <!-- libraryName -->
    <opac-table-cell-text *ngIf="showLibraryCell">{{ item.libraryName }}</opac-table-cell-text>
    <!-- availability -->
    <opac-table-cell-text>
      <ng-container *ngIf="!item.returnDate">
        {{ 'general.physical.' + item.availability | lowercase | translate }}
      </ng-container>
      <ng-container *ngIf="item.returnDate">
        {{ 'general.physical.on_loan_until' | translate }} {{ item.returnDate }}
      </ng-container>
    </opac-table-cell-text>
    <!-- each header -->
    <opac-table-cell-text *ngFor="let header of physicalRecordHeaders">{{ item[header] ? item[header] : '-' }}</opac-table-cell-text>
    <!-- button cell -->
    <opac-table-cell class="button-cell">
      <app-record-buttons
        class="record-buttons"
        from="RECORD_SCREEN"
        [record]="record"
        [physicalRecord]="item"
        [config]="buttonsConfig">
      </app-record-buttons>

      <opac-button type="text" class="show-all-information" [ariaLabel]="'general.viewMore' | translate" [opacTooltip]="'general.viewMore' | translate" (click)="openPhysicalRecordInfoDialog(item)">
        {{ 'general.physical.moreButton' | translate }}
      </opac-button>
    </opac-table-cell>
  </opac-table-row>
</opac-table>

<div class="paginator" *ngIf="physicalAvailabilityItems.length > pageSize">
  <mat-paginator
    [length]="physicalAvailabilityItems.length"
    [pageSize]="pageSize"
    (page)="physicalPage($event)"
    [hidePageSize]="true"
    [showFirstLastButtons]="true">
  </mat-paginator>
</div>

<div *ngIf="physicalAvailabilityItems.length > pageSize" class="show-all-records">
  <opac-button type="text" (click)="isAllItemsDialogOpened = true">
    {{ 'info.physicalRecord.viewAllCopies' | translate }}
  </opac-button>
</div>

<opac-dialog [title]="'info.physicalRecord.dialogTitle' | translate" [size]="'full'" [open]="isAllItemsDialogOpened" (closed)="isAllItemsDialogOpened = false">
  <opac-table>
    <opac-table-row>
      <!-- libraryName -->
      <opac-table-cell-header *ngIf="showLibraryCell">{{ 'physical.library' | translate }}</opac-table-cell-header>
      <!-- availability -->
      <opac-table-cell-header>{{ 'physical.availability' | translate }}</opac-table-cell-header>
      <!-- button cell -->
      <opac-table-cell-header></opac-table-cell-header>
    </opac-table-row>

    <opac-table-row *ngFor="let item of physicalAvailabilityItems">
      <!-- libraryName -->
      <opac-table-cell-text *ngIf="showLibraryCell">{{ item.libraryName }}</opac-table-cell-text>
      <!-- availability -->
      <opac-table-cell-text>
        <ng-container *ngIf="!item.returnDate">
          {{ 'general.physical.' + item.availability | lowercase | translate }}
        </ng-container>
        <ng-container *ngIf="item.returnDate">
          {{ 'general.physical.on_loan_until' | translate }} {{ item.returnDate }}
        </ng-container>
      </opac-table-cell-text>
      <!-- button cell -->
      <opac-table-cell class="button-cell">
        <opac-button type="text" class="show-all-information" [opacTooltip]="'general.viewMore' | translate" (click)="openPhysicalRecordInfoDialog(item)">
          {{ 'general.physical.moreButton' | translate }}
        </opac-button>
      </opac-table-cell>
    </opac-table-row>
  </opac-table>
</opac-dialog>

<opac-dialog [open]="isInfoItemDialogOpened" (closed)="isInfoItemDialogOpened = false">
  <div *ngIf="selectedItem !== null" class="dialog-container">
    <div class="grid-list">
      <!-- libraryName -->
      <div *ngIf="showLibraryCell">{{ 'physical.library' | translate }}</div>
      <div *ngIf="showLibraryCell">{{ selectedItem.libraryName }}</div>

      <!-- availability -->
      <div>{{ 'physical.availability' | translate }}</div>
      <div>
        <ng-container *ngIf="!selectedItem.returnDate">
          {{ 'general.physical.' + selectedItem.availability | lowercase | translate }}
        </ng-container>
        <ng-container *ngIf="selectedItem.returnDate">
          {{ 'general.physical.on_loan_until' | translate }} {{ selectedItem.returnDate }}
        </ng-container>
      </div>

      <!-- each header -->
      <ng-container *ngFor="let header of allRecordHeaders">
        <div>{{ header }}</div>
        <div>{{ selectedItem[header] ? selectedItem[header] : '-' }}</div>
      </ng-container>
    </div>

    <app-record-buttons
      class="modal-record-buttons"
      from="RECORD_SCREEN"
      [record]="record"
      [physicalRecord]="selectedItem"
      [config]="buttonsConfig">
    </app-record-buttons>
  </div>
</opac-dialog>
